import { useStartAudit } from './useStartAudit';

/**
 * Dark "Learn the truth" final CTA block, shared by the landing page and the
 * legal documents (shown above the footer).
 */
export default function LandingFinalCta() {
  const startAudit = useStartAudit();
  return (
    <section className="final" id="cta">
      <div className="final-in">
        <h2>Learn the truth<br /><em>about your business.</em></h2>
        <p>Not in six months, not at quarter's end. In 1 hour — with concrete numbers.</p>
        <div className="final-btns">
          <button className="btn btn-light btn-lg" onClick={startAudit}>Order your audit — Free <span className="arr">→</span></button>
        </div>
        <div className="final-note"><span><svg viewBox="0 0 24 24"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1Z" /><path d="m9 12 2 2 4-4" /></svg>NDA signed</span><span><svg viewBox="0 0 24 24"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" /></svg>Read-only access</span><span><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3.5 2" /></svg>Ready in 1 hour</span></div>
      </div>
    </section>
  );
}
